import useAuthStore from 'store/auth';
import useFaceScanStore from 'store/face-scan';

export const getProfileId = () =>
  useAuthStore.getState().currentUserProfileId || '';

export const getLocale = () =>
  useAuthStore.getState().locale
    ? useAuthStore.getState().locale + '-us'
    : 'en-us';

export const getBinahKey = () =>
  useFaceScanStore.getState().sdkConfig?.binaah_sdk_key || '';
